import * as Yup from "yup";

export const xarReportFormInitialValues = {
  reportMode: "byDriver",
  driverId: "",
  keyId: "",
  objectIds: [],
  startDate: "",
  endDate: "",
  assignedToAllObjects: true
};

export const xarReportFilterInitialValues = {
  driverId: "",
  objectIds: [],
  assignedToAllObjects: true,
  dateRange: {
    startDate: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000),
    endDate: new Date()
  }
};

export const xarReportFormValidationSchema = (t: any) =>
  Yup.object().shape({
    reportMode: Yup.string().required(),
    driverId: Yup.string()
      .nullable()
      .when("reportMode", ([reportMode], schema) => {
        return reportMode === "byDriver"
          ? schema.required(t("validation.driverRequired"))
          : schema;
      }),
    keyId: Yup.string().nullable(),
    objectIds: Yup.array().of(Yup.string()),
    startDate: Yup.string(),
    endDate: Yup.string(),
    assignedToAllObjects: Yup.boolean()
  });

export const xarReportFilterValidationSchema = Yup.object().shape({
  driverId: Yup.string().nullable(),
  objectIds: Yup.array().of(Yup.string()),
  assignedToAllObjects: Yup.boolean(),
  dateRange: Yup.object().shape({
    startDate: Yup.date().required(),
    endDate: Yup.date().required()
  })
});
